import InstructionPage from '@/pages/instruction/layout'
import InstructionIndexPage from '@/pages/instruction/index'
import InstructionLessonPage from '@/pages/instruction/lesson'

const routes = {
	path: '/instruction',
	component: InstructionPage,
	meta: {title: 'Рассылки', breadcrumb: 'Рассылки'},
	children: [
		{
			path: '',
			component: InstructionIndexPage,
			meta: {title: 'Инструкция'}
		},
		{
			path: 'lesson/:id',
			component: InstructionLessonPage,
			meta: {title: 'Урок'}
		}
	]
}

export default {
	routes
}



// WEBPACK FOOTER //
// ./src/routes/instruction.js